import useTermButton from './useTermButton';

import { TermStandardButtonValues } from '../Standard/useTermsStandard';

export interface TermButtonProps extends TermStandardButtonValues {
  deferred?: boolean;
}

const TermButton: React.FunctionComponent<TermButtonProps> = function ({
  term,
  label,
  id,
  onClick,
  deferred = false,
}) {
  const { buttonClassName } = useTermButton(term, deferred);
  return (
    <button type="button" id={id} onClick={onClick} className={buttonClassName}>
      {label}
    </button>
  );
};

export default TermButton;
